import dayjs from 'dayjs'
import { useBrandPlanSchedules } from 'hooks/queries/schedules/useBrandPlanSchedules'
import { getTotalCountFromInfiniteQuery } from 'utils/query'

export const useNoCampaignGuard = (brandPlanId: number | undefined) => {
  const schedulesQuery = useBrandPlanSchedules(
    {
      brandPlanId: brandPlanId ?? 0,
      start_date: dayjs().format('YYYY-MM-DD'),
      order_direction: 'asc',
    },
    {
      enabled: !!brandPlanId,
    },
  )

  return {
    isLoading: schedulesQuery.isLoading,
    hasNoCampaigns: schedulesQuery.isFetched && getTotalCountFromInfiniteQuery(schedulesQuery) === 0,
  }
}
